import ApiClient from 'clients/api_client'
import RecruiterDestination from 'entities/user_notice/recruiter_destination'
import Pagination from 'entities/pagination'

export default class RecruiterDestinationClient {
  static getRecruiterDestinations(contentId, status, page = 1) {
    const params = {
      status,
      page
    }
    const url = Routes.userNoticeMailsDestinationsRecruitersPath(contentId, params)
    return ApiClient.get(url).then(({ data, headers }) => {
      const destinations = data.map(d => RecruiterDestination.fromJson(d))
      const pagination = Pagination.fromJsonLowerCased(headers)

      return {
        destinations,
        pagination
      }
    })
  }
}
